import {Component, Input, OnInit} from '@angular/core';
import {SafeResourceUrl} from "@angular/platform-browser";
import {BasePageComponent} from "../../base-page.component";
import {AuthService} from "../../services/auth.service";
import {
  ChangePassword,
  EmailResetPasswordDto,
  LoginRequest,
  ResetPassword,
  SignInRequest
} from '../../models/auth.models';
import { RegistrationService } from 'src/app/services/domain/registration.service';
import { RegistrationRequest } from 'src/app/models/registrazione.models';
import { RegistryService } from 'src/app/services/domain/registry.service';
import { PatternValidator } from '@angular/forms';
import { SettingsComponent } from '../settings/settings.component';
import { ActivatedRoute } from '@angular/router';

//lasciare SignInRequest o crearne uno nuovo?

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.css'],
  providers: [RegistryService]

})
export class ForgotComponent extends BasePageComponent  implements OnInit {

public loginRequestModel : SignInRequest = new SignInRequest();
public passwordRequestModel: ResetPassword = new ResetPassword();
public passwordReset: RegistrationRequest = new RegistrationRequest();
public showResetPassword : boolean = false;
public changePasswordrequest : ChangePassword = new ChangePassword();
public code : string | null = null;
@Input() internal: boolean = false;

  constructor(private registryService : RegistryService, private route : ActivatedRoute) {
    super();

  }

  ngOnInit(): void {
    let x = this.internal;
   this.code = this.route.snapshot.paramMap.get('code');
   if(this.code == null || this.code == ""){
      this.showResetPassword=false;
   }
   else{
      this.showResetPassword=true;
   }


  }

//controllo sulla mail inserita per la richiesta di reset
  public async resetPassword(){
    if(!this.internal){
      if (this.loginRequestModel.username == "" || !RegExp('^[a-z0-9._%+-]+@[a-z0-9-]+\.[a-z]{2,4}$').test(this.loginRequestModel.username))
        return this.showError("Email Non Valida");
    }

    let model : EmailResetPasswordDto = new EmailResetPasswordDto();
    model.Email = this.loginRequestModel.username;
    model.IdAnagraficaUtente = AuthService.LoggedUser?.profileId ?? 0;
    if((this.loginRequestModel.username == null || this.loginRequestModel.username == "") && model.IdAnagraficaUtente == 0)
      return this.showError("Email non valida");

      this.asyncCall(() => this.registryService.resetPassword(model), response => {
        this.showSuccess("Ti abbiamo inviato una mail per il reset della password");
      });
  }


  public controllaPassword(){
    if(this.passwordRequestModel.oldpassword == "" || this.passwordRequestModel.newpassword ==""){
      this.showError("Riempi Tutti i Campi");
    }
    else if(this.passwordRequestModel.newpassword == this.passwordRequestModel.oldpassword){
      this.changePasswordrequest.password=this.passwordRequestModel.newpassword;
      this.changePasswordrequest.code = this.code;
      this.changePasswordrequest.email = this.passwordRequestModel.email;
      this.asyncCall(() => this.registryService.changePassword(this.changePasswordrequest), response => {
        this.showSuccess("Password cambiata!")
        this.navigate(['/signin']);
      });
    }
    else{
      this.showError("Le password non Coincidono");
    }
  }
}
